import React, { useState } from 'react';
import { useAdminStore } from '../../../lib/store-admin';
import { InstitutionUserList } from './InstitutionUserList';
import { InstitutionModal } from './InstitutionModal';

export const InstitutionDetails: React.FC<{ onViewReport: () => void }> = ({ onViewReport }) => {
    const { selectedInstitution, setSelectedInstitution } = useAdminStore();
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    if (!selectedInstitution) return null;

    const handleBack = () => {
        setSelectedInstitution(null);
    };

    return (
        <div className="institution-details-view">
            <div className="action-bar js-sb">
                <div className="header-left">
                    <button className="btn-back" onClick={handleBack}>
                        <span className="material-symbols-outlined">arrow_back</span>
                    </button>
                    <div>
                        <h1>{selectedInstitution.name}</h1>
                        <p>Kurum detayları ve kullanıcı yönetimi.</p>
                    </div>
                </div>
                <button className="btn-secondary" onClick={() => setIsEditModalOpen(true)}>
                    <span className="material-symbols-outlined">edit</span>
                    Kurumu Düzenle
                </button>
            </div>

            <div className="details-content" style={{ marginTop: '24px' }}>
                <div className="institution-info-card" style={{ background: 'white', padding: '24px', borderRadius: '8px', border: '1px solid #e5e7eb', marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '24px' }}>
                    <div className="logo-preview" style={{ width: '80px', height: '80px', borderRadius: '8px', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f9fafb' }}>
                        {selectedInstitution.logo_url ? (
                            <img src={selectedInstitution.logo_url} alt={selectedInstitution.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                        ) : (
                            <span className="material-symbols-outlined" style={{ fontSize: '32px', color: '#9ca3af' }}>apartment</span>
                        )}
                    </div>
                    <div>
                        <h2 style={{ fontSize: '18px', fontWeight: 600, color: '#111827', marginBottom: '4px' }}>{selectedInstitution.name}</h2>
                        <span className={`status-badge ${selectedInstitution.is_active ? 'active' : 'inactive'}`}>
                            {selectedInstitution.is_active ? 'Aktif' : 'Pasif'}
                        </span>
                    </div>
                </div>

                <InstitutionUserList institutionId={selectedInstitution.id} onBack={handleBack} onViewReport={onViewReport} />
            </div>

            {isEditModalOpen && (
                <InstitutionModal
                    isOpen={isEditModalOpen}
                    onClose={() => setIsEditModalOpen(false)}
                    institution={selectedInstitution}
                />
            )}
        </div>
    );
};
